"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DUMMY_MSN = exports.UNIVERSAL_TRAD_METER_TYPE = exports.BACKUP_STARTDATE = exports.SMART_METER_NON_COMMS_DAYS = exports.SUBMISSION_WINDOW_DAYS = exports.ONBOARDING_DAYS = exports.SUPPLY_LOCAL_TIME_FORMAT = exports.DATE_API_FORMAT = exports.DATETIME_FORMAT = exports.DATE_FORMAT = exports.KAPI_PAGINATION_LIMIT = exports.PAGE_SIZE = exports.MOBILE_WIDTH = void 0;
exports.MOBILE_WIDTH = 768;
exports.PAGE_SIZE = 12;
// Temporary hardcoded limit to number of reads requested
// This is to attempt to keep under Kapi's response size limit
// while we don't have time to implement proper pagination
exports.KAPI_PAGINATION_LIMIT = 10000;
exports.DATE_FORMAT = 'd MMM yyyy';
exports.DATETIME_FORMAT = 'h:mmaaa, d MMM yyyy';
exports.DATE_API_FORMAT = 'yyyy-MM-dd';
exports.SUPPLY_LOCAL_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ssxxx";
exports.ONBOARDING_DAYS = 6;
exports.SUBMISSION_WINDOW_DAYS = 9;
exports.SMART_METER_NON_COMMS_DAYS = 5;
exports.BACKUP_STARTDATE = new Date('1990-01-01');
exports.UNIVERSAL_TRAD_METER_TYPE = 'basic';
// export const UNIVERSAL_SMART_METER_TYPE = 's2';
exports.DUMMY_MSN = 'Unknown';
